import { useApiUrl } from '../../../../../../global/config/useApiUrl';
import { useCampfireFetch } from '../../../../../../global/network/useCampfireFetch';
import { CreatWidgetFormValues, WidgetTypes } from './dashboard-widget-model';
import { EMPTY_PWI, pwiItemsFromForm } from './forms/PwiWidgets/PwiWidgetForm';

type IPosition = {
  row: number;
  col: number;
  rowSpan: number;
  colSpan: number;
};

export const useSaveWidget = () => {
  const uri = useApiUrl();
  const campfireMutation = useCampfireFetch({ defer: true });
  return (widget: CreatWidgetFormValues, position: IPosition, dashboardComponentId?: string, orgDashboard = false) => {
    if (widget.byType === WidgetTypes.PWI) {
      const pwi = widget.pwi ?? EMPTY_PWI;
      return campfireMutation.run({
        url: `${uri}/vm/preferences/dashboard-component/save`,
        method: 'POST',
        data: {
          dashboardComponentId,
          orgDashboard,
          position,
          name: pwi.name.trim() || 'PWI',
          widget: { widgetType: WidgetTypes.PWI },
          filters: { programIds: pwi.programIds, taskId: pwi.taskId, items: pwiItemsFromForm(pwi) },
          targets: [],
        },
      });
    }

    if (widget.byType === WidgetTypes.NUMBER_CHART) {
      return campfireMutation.run({
        url: `${uri}/vm/preferences/dashboard-component/save`,
        method: 'POST',
        data: {
          dashboardComponentId,
          orgDashboard,
          position,
          name: `chart-number-${widget.numberWidgetType}-${widget.chartWidgetType}`,
          widget: {
            widgetType: widget.byType,
            number: {
              numberType: widget.numberWidgetType,
              range: widget.highlight,
              interval: widget.interval,
              target: widget.target,
              customMultiplier: widget.customMultiplier,
            },
            chart: {
              chartType: widget.chartWidgetType,
              dimension: widget.dimension,
              range: widget.range,
              interval: widget.interval,
              group: widget.group === 'none' ? null : widget.group,
            },
          },
          filters: {
            activityIds: widget.activityIds,
            programIds: widget.programIds,
            activityTags: widget.tagIds,
            fieldIds: widget.fieldIds,
            optionIds: widget.optionIds ?? [],
            roleIds: widget.roleIds ?? [],
          },
          targets: widget.byValues,
        },
      });
    }

    return campfireMutation.run({
      url: `${uri}/vm/preferences/dashboard-component/save`,
      method: 'POST',
      data: {
        dashboardComponentId,
        orgDashboard,
        position,
        widgetType: widget.byType,
        name: `${widget.byType}-${widget.range}`,
        widget: {
          widgetType: widget.byType,
          numberType: widget.numberWidgetType,
          chartType: widget.chartWidgetType,
          dimension: widget.dimension,
          range: widget.range,
          interval: widget.interval,
          group: widget.group === 'none' ? null : widget.group,
          target: widget.target,
          customMultiplier: widget.customMultiplier,
        },
        filters: {
          activityIds: widget.activityIds,
          programIds: widget.programIds,
          activityTags: widget.tagIds,
          fieldIds: widget.fieldIds,
          optionIds: widget.optionIds ?? [],
          roleIds: widget.roleIds ?? [],
        },
        targets: widget.byValues,
      },
    });
  };
};

export const useSaveWidgetLayout = () => {
  const uri = useApiUrl();
  const campfireMutation = useCampfireFetch({ defer: true });
  return (dashboardComponentId: string, position: IPosition, orgDashboard = false) =>
    campfireMutation.run({
      url: `${uri}/vm/preferences/dashboard-component-layout/save`,
      method: 'POST',
      data: {
        dashboardComponentId,
        position,
        orgDashboard,
      },
    });
};
